<!-- 餐饮企业详情 -->
<template>
  <div class="dialog-restaurant">
    <div class="header">
      <div class="title">{{ data.qymc || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <div class="descriptions-item width100">
            <span class="key">企业名称:</span>
            <span class="value">{{ data.qymc || '-' }}</span>
          </div>
          <div class="descriptions-item width100">
            <span class="key">联系人:</span>
            <span class="value">{{ data.glr || '-' }}</span>
          </div>
          <div class="descriptions-item width100">
            <span class="key">联系人电话:</span>
            <span class="value">{{ data.glrLxfs || '-' }}</span>
          </div>
          <div class="descriptions-item width100">
            <span class="key">详细地址:</span>
            <span class="value">{{ data.szdz || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  // eslint-disable-next-line no-undef
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.dialog-restaurant {
  width: 46rem;
  min-width: 46rem;
  .header {
    text-align: left;
    margin-bottom: 5px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          display: flex;
          &.width100 {
            width: 100%;
          }
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
